import { connect } from 'react-redux';
import Landing from 'views/profile/landing/MenuLanding';

export default connect(null, null)(Landing);
